import React, { Component } from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import PaperBox from '~shared/components/atoms/PaperBox'
import FormElementsGroup from '~shared/components/organisms/FormElementsGroup'

class Form extends Component {
  _fieldsRef

  render() {
    const {
      classes,
      name,
      title,
      buttonLabel,
      buttonId,
      buttonName,
      isSubmitting,
      elements,
      externalErrors,
      extra,
    } = this.props

    return (
      <form noValidate className={classes.root} name={name}>
        <PaperBox
          title={title}
          pending={isSubmitting}
          buttonLabel={buttonLabel}
          buttonName={buttonName}
          buttonId={buttonId}
          onButtonClick={this._handleButtonClick}
          moreComponents={extra}
          classes={{ headline: classes.headline }}
        >
          <FormElementsGroup
            externalErrors={externalErrors}
            elements={elements}
            innerRef={ref => {
              this._fieldsRef = ref
            }}
          />
        </PaperBox>
      </form>
    )
  }

  _handleButtonClick = e => {
    e.preventDefault()

    if (!this._fieldsRef || !this._fieldsRef.checkValidity()) {
      return
    }

    const { onSubmitClick } = this.props
    onSubmitClick && onSubmitClick(this._fieldsRef.getValues())
  }
}

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  headline: {
    textTransform: 'inherit',
    textAlign: 'center',
  },
})

export default withStyles(styles)(Form)
